import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AddToGroupArg, CreateGroupArg, GetReportsArg, GetTabArg, GetTabResponse, GroupsType, idWorkerType, RemoveFromGroupArg, ResponseAddToGroupType, ResponseCreateGroupType, ResponseGetReportsType, ResponseGroupsType, ResponseRemoveFromGroupType, ResponseUpdateWorkerType, UpdateWorkerArg } from './type';

const token = localStorage.getItem('token');

const api = 'api2';

export const workerApi = createApi({
  reducerPath: 'workerApi',
  tagTypes: ['Worker', 'Reports', 'Groups', 'WorkerSupport'],
  refetchOnReconnect: true,
  keepUnusedDataFor: 15,
  baseQuery: fetchBaseQuery({
    baseUrl: `https://${api}.skilla.ru/api/`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
      Accept: 'application/json',
    },
  }),
  endpoints: (build) => ({
    getGroups: build.query<GroupsType[], idWorkerType>({
      query: ({ idWorker }) => ({
        url: `/workers/${idWorker}/groups`,
        method: 'GET',
      }),
      providesTags: () => ['Groups'],
      transformResponse: (response: ResponseGroupsType) => response?.data,
    }),
    getReports: build.query<ResponseGetReportsType, GetReportsArg>({
      query: ({ idWorker, params }) => ({
        url: `/workers/${idWorker}/show/reports`,
        method: 'GET',
        params,
      }),
      providesTags: () => ['Reports'],
    }),
    updateWorker: build.mutation<ResponseUpdateWorkerType, UpdateWorkerArg>({
      query: ({ idWorker, params, body, docs_accept }) => ({
        url: `/workers/${idWorker}/update?${docs_accept === 1 ? '&app_verified=1' : ''}`,
        method: 'POST',
        body,
        headers: {
          Accept: 'application/json',
          Authorization: token ? `Bearer ${token}` : '',
        },
        params: params,
      }),
      invalidatesTags: ['Worker'],
    }),
    createGroup: build.mutation<ResponseCreateGroupType, CreateGroupArg>({
      query: (params) => ({
        url: `/workers/groups/store`,
        method: 'POST',
        params,
      }),
      invalidatesTags: ['Groups'],
    }),
    addToGroup: build.mutation<ResponseAddToGroupType, AddToGroupArg>({
      query: ({ worker_id, group_id }) => ({
        url: `/workers/${worker_id}/groups/${group_id}/add`,
        method: 'POST',
      }),
      invalidatesTags: ['Groups'],
    }),
    removeFromGroup: build.mutation<ResponseRemoveFromGroupType, RemoveFromGroupArg>({
      query: ({ worker_id, group_id }) => ({
        url: `/workers/${worker_id}/groups/${group_id}/delete`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Groups'],
    }),
    getTab: build.query<GetTabResponse[], GetTabArg>({
      query: ({ id, title, name }) => ({
        url: `/${name}/${id}/tabs/${title}`,
        method: 'GET',
      }),
      transformResponse: (
        response: { data?: GetTabResponse[] } & Record<string, unknown>,
      ) => response?.data || [],
    }),
  }),
});

export const {
  useGetTabQuery,
  useGetReportsQuery,
  useUpdateWorkerMutation,
  useGetGroupsQuery,
  useCreateGroupMutation,
  useAddToGroupMutation,
  useRemoveFromGroupMutation,
} = workerApi;
